// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"6bbeddea","864":"74ab4c7e","983":"74ab4c7e"}[chunkId] + ".chunk.css";
};